<template>
  <v-row align="center">

    <!-- <v-flex xs4>
      <v-menu bottom offset-y open-on-hover min-width="240">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            Edit
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item v-for="i in 4" :key="i" @click="">
            <v-list-item-title>{{ i }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-for="i in 5" :key="i" @click="">
            <v-list-item-title>{{ i + 5 }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-flex> -->

    <!-- <v-toolbar> -->
    <!-- <v-toolbar-title>Filter</v-toolbar-title>

    <v-select
      :items="eventTypes"
      v-model="eventDefault"
      attach
      chips
      label="Event type"
      multiple
      clearable
    ></v-select>

    <v-text-field
    single-line
    ></v-text-field> -->



    <!-- <v-select
      :items="geo"
      v-model="geoDefault"
      attach
      label="Where to promote"
    ></v-select> -->

    <!-- </v-toolbar> -->
    <v-col md="1">
      <span style="font-size: 18px; font-weight: 400;">Helpers: </span>
    </v-col>

    <v-col md="7">
      <v-menu
        offset-y
        :close-on-content-click="false"
        content-class="image-menu"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-3"
          >
            Images
          </v-btn>
        </template>

        <!-- <v-list>
          <v-list-item
            v-for="(item, index) in snippets.images"
            :key="index"
            @click="copyTextToClipboard(item.url)"
            class="ma-1"
            >
              <v-img
                :src="item.url"
                width = "100"
                max-width = "100"
                max-height = "100"
                class = "mr-2"
              ></v-img>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list> -->

        <v-card max-width="400px">
          <menu-data-table
            :images="snippets.images"
            menu="image-menu"
          />
        </v-card>
      </v-menu>

      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-3"
          >
            Ad text
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in snippets.ad_text"
            :key="index"
            @click="copyText(item.value)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-3"
          >
            Snippets
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in snippets.snippets"
            :key="index"
            @click="copyText(item.value)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-3"
            @click=""
          >
            Templates
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in null"
            :key="index"
            @click="copyText(item.value)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <v-col cols="auto" class="ml-auto mr-4">
      <v-btn color="primary" @click="">
        Create ads
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import imageArray from '../../../../static/dummy-data/sample-images-biden.json'
import MenuDataTable from '../helpers/MenuDataTable'
import { copyTextToClipboard } from '../../../helpers/functions'

  export default {
    name: 'AdsHelpers',
    components: {
      MenuDataTable
    },
    props: {
      data: {
        type: Array
      },
      hotRef: {}
    },
    data () {
      return {
        eventTypes: ['Barnstorm', 'Canvass', 'Carpool', 'Community Canvass', 'Community Event', 'Friend-to-Friend Outreach', 'House Party', 'Meet-and-Greet', 'Meeting', 'Office Opening', 'Other', 'Phone Bank', 'Rally', 'Signature Gathering', 'Solidarity Event', 'Text Bank', 'Town Hall', 'Training', 'Voter Registration', 'Watch Party'],
        eventDefault: ['Phone Bank', 'Text Bank', 'Canvass'],
        snippets: {
          images: imageArray,
          ad_text: [
            { title: 'More than 70 polls',
              value: 'It’s more clear than ever: Joe Biden is our best chance at getting Trump out of the White House. More than 70 nationwide polls show him defeating Donald Trump in November.\n\n' },
            { title: 'Joe is the only candidate',
              value: 'Joe is the only candidate who has what it takes to beat Donald Trump next November.\n\n' },
            { title: 'Joe and Tim Kaine',
              value: 'Joe Biden and Senator Tim Kaine are coming to Norfolk!\n\n' },
            { title: 'Coming to Dallas',
              value: 'Joe Biden is coming to Dallas!  ' },
            { title: 'Every single time the Democratic Party',
              value: 'Every single time the Democratic Party has captured the White House over the last century, the nominee has been somebody who\'s new on the national scene, has not run for president before, and is opening the door to a new generation of leadership. We need to think about that in order to be sure that we defeat Donald Trump.\n\n' },
            { title: 'Hear what issues and values matter',
              value: 'share about Joe Biden and hear what issues and values matter to folks in the community' },
            { title: 'Org powered by people like you',
              value: 'We\'re building an organization that can win, powered by people like you––not corporate PACs or federal lobbyists.\n\n' },
            { title: 'Turn the page on broken politics',
              value: 'It\'s time to turn the page on our broken politics and show the American people that we can do things that have never been done before.\n\n' }
          ],
          invites: [
            { title: 'Come canvass with the Joe Biden campaign',
              value: 'Come canvass with the Joe Biden campaign ' },
            { title: 'Come join #TeamJoe',
              value: 'Come join #TeamJoe ' },
            { title: 'Come join us',
              value: 'Come join us ' },
            { title: 'Join Team Joe supporters',
              value: 'Join Team Joe supporters ' },
            { title: 'Talking to friends and neighbors',
              value: 'We\'ll be talking to your friends and neighbors about our campaign ' }
          ],
          snippets: [
            { title: 'Joe Biden',
              value: 'Joe Biden ' },
            { title: 'Team Joe Biden',
              value: 'Team Joe Biden ' },
            { title: '#TeamJoe',
              value: '#TeamJoe ' },
            { title: 'Only a few days',
              value: 'Only a few days until the primary, ' },
            { title: 'Only a few weeks',
              value: 'Only a few weeks until the primary, ' }
          ]
        },
        geo: ['Same zip', '+5 mi', '+10 mi', '+20 mi', '+40 mi'],
        geoDefault: '+10 mi'
      }
    },
    computed: {
    },
    methods: {
      copyText (text) {
        return copyTextToClipboard(text)
      },
      exportDataTable () {
        const exportPlugin = this.hotRef.getPlugin('exportFile')
        exportPlugin.downloadFile('csv', {
            bom: false,
            columnDelimiter: ',',
            columnHeaders: true,
            exportHiddenColumns: true,
            exportHiddenRows: true,
            fileExtension: 'csv',
            filename: 'local-event-ads_[YYYY]-[MM]-[DD]',
            mimeType: 'text/csv',
            rowDelimiter: '\r\n',
            rowHeaders: false
          })
      }
    }
  }
</script>
